<template>
  <div 
    id="mostrarAvisosNaVenda" 
    v-if="mostrar_modal"
    style="display: block; padding-top: 200px; "
    class="w3-modal" 
    v-cloak>

    <div class="w3-modal-content w3-container w3-animate-zoom" @click.stop>
      <header class="w3-container">
        <h4 class="texto-vermelho w3-center">Avisos de Venda</h4>
      </header> 

      <div class="w3-col s12" style="padding-left: 10px; padding-bottom: 10px;">
        <label style="font-size:12px; font-style: italic;">
          É necessário confirmar a leitura dos avisos abaixo.
        </label>
      </div>

      <div 
        class="w3-row-padding w3-animate-left w3-col s12 card-item"
        v-bind:style="getClasseDescricao(index)"
        v-for="(aviso, index) in avisos"
        :key="index" 
        v-cloak>
        <div v-on:click="mostrarTextoMensagem(index)">
          <div class="w3-container" style="padding:10px 5px" >
            
            <div class="w3-col s12">
              <span>
                <i class="far fas fa-dot-circle" style="color: #737373;" v-if="!aviso.leitura"></i>
                <i class="far fas fa-check-circle" style="color: #329c6c;" v-if="aviso.leitura"></i>
              </span>
              
              <label 
                v-bind:style="getClasseDescricao(index)">
                <strong>{{aviso.descricao}}</strong>
              </label>

              <p
                v-bind:style="getClasseMensagem(index)"
                class="label-clicavel">
                <i v-bind:class="getIcone(aviso.tipo_aviso)"></i>
                {{aviso.mensagem}}
              </p>
            </div>

          </div>
        </div>
      </div>

      <div class="w3-col s12 w3-center">
        <button 
          class="w3-button w3-theme" 
          @click="confirmarLeitura()"> 
          <i class="fas fa-check-circle"></i>
        </button>
      </div>
    </div> 
  </div>
</template>

<script>
  import formatarValorMixin from '@/mixins/formatarValorMixin'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
  import ROrcamentoBuscarAvisosRestricoesCliente from '@/components/Rest/ROrcamento/ROrcamentoBuscarAvisosRestricoesCliente.js'

  export default {
    name: 'MostrarAvisosNaVenda',
    props:{
      retornoAvisosNaVenda: Function,
    },
    mixins:[formatarValorMixin],
    data() {
      return {
        api: process.env.API,
        mostrar_modal: false,
        avisos: undefined,
      }
    },
    watch: {
      mostrar_modal() {
        this.verificarModalAberto()   
      },
    },  
    methods: {

      async buscarAvisosRestricoesCliente(
        condicao_id, 
        cliente_id, 
        vendedor_id, 
        total_pedido, 
        fechando_pedido, 
        carregando_orcamento, 
        informativo, 
        tipo_entrega, 
        campo
      ) {
        try {

          let parametros = {
            condicao_id: condicao_id,
            cliente_id: cliente_id,
            vendedor_id: vendedor_id,
            total_pedido: total_pedido,
            fechando_pedido: fechando_pedido,
            carregando_orcamento: carregando_orcamento,
            informativo: informativo,
            tipo_entrega: tipo_entrega,
            campo: campo
          }

          let retorno = await ROrcamentoBuscarAvisosRestricoesCliente.buscarAvisosRestricoesCliente(this.axios, parametros)

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          for (let i = 0; i < retorno.dados.avisos.length; i++) {
            retorno.dados.avisos[i].leitura = false;
            retorno.dados.avisos[i].mensagem = retorno.dados.avisos[i].mensagem.replace(/\\n/g, String.fromCharCode(13) + String.fromCharCode(10));
          }

          await this.retornoAvisosNaVenda(retorno);
        } catch (error) {
          this.verificarErro(error, 'buscarAvisosRestricoesCliente')  
        }
      },

      verificarErro(erro, nome_funcao){
        Biblioteca.gerarLogNomeFuncao('MostrarAvisosNaVenda.vue -> ' + nome_funcao);
        let mensagem = Biblioteca.tratamentoMensagem(erro);
        Biblioteca.exclamar(mensagem);
      },

      exibirAvisosNaVenda(avisos){
        this.avisos = avisos;

        if (this.avisos.length > 0){
          this.mostrar_modal = true;
        }
      },
      
      getIcone(tipo_aviso){
        if (tipo_aviso === 'ENT')
          return 'fas fa-truck'
        else if (tipo_aviso === 'CLI')
          return 'fas fa-comment'
        else if (tipo_aviso === 'VEN')
          return 'fas fa-user-tag'
        else if (tipo_aviso === 'ANI')
          return 'fas fa-birthday-cake'
        else if (tipo_aviso === 'INC')
          return 'fas fa-id-card'
        else if (tipo_aviso === 'SOC')
          return 'fas fa-users'
        else if (tipo_aviso === 'FIL')
          return 'fas fa-city'
        else 
          return 'fas fa-check-double';
      },

      verificarModalAberto(){
        const el = document.documentElement
        if (this.verificarModal) {
          el.classList.add('modal-aberto');
        } else {
          el.classList.remove('modal-aberto');
        } 
      },

      mostrarTextoMensagem(index){
        this.avisos[index].leitura = true;
        this.$forceUpdate();
      },

      confirmarLeitura(){
        for (let i = 0; i < this.avisos.length; i++) {
          if (!this.avisos[i].leitura) {
            Biblioteca.exclamar('Clique nos avisos para confirmar a leitura!');
            return;
          }
        }
        
        this.mostrar_modal = false;
      },

      getClasseDescricao(index){
        if (this.avisos[index].leitura){
          return "cursor: pointer; background-color: #eaebd1; color: #329c6c;";
        } else{
          return "cursor: pointer; color: #212121; ";
        }
      },

      getClasseMensagem(index){
        if (this.avisos[index].leitura){
          return "margin:0; padding:0;  font-size:12px; font-weight:bold; font-style: italic; background-color: #eaebd1; color: #737373;";
        }
        else{
          return "margin:0; padding:0; font-size:12px; font-weight:bold; color: #212121;";
        }
      },
    },
    computed: {
      verificarModal() {
        if (
          this.abrir_modal
        ) return true
        else return false     
      }
    }
  }
</script>

<style scoped>

.card-mensagem-confirmada {
  margin-bottom: 10px;
  border-left-style: solid;
  border-left-color: #636363 !important;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: #636363 !important;
  background: #bfd6bf;
  color:#4a4a4a;
}
.card-mensagem-confirmada:hover {
  margin-bottom: 10px;
  border-left-style: solid;
  border-left-color: #636363 !important;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: #636363 !important;
  background: #e1f7e3;
  color: #4a4a4a;
}
.card-mensagem-nao-confirmada {
  margin-bottom: 10px;
  border-left-style: solid;
  border-color: #4f4f4f !important;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: #4f4f4f !important;
  transition: all 0.3s ease-out;
  color: #4a4a4a;
}

.card-mensagem-nao-confirmada:hover {
  background: #ededed;
}

.card-item {
    background-color: #f3f3f3;
    border-radius: 10px;
    box-shadow: #7a7a7a 1px 2px 5px 2px ;
    margin-bottom: 10px;
    padding: 5px !important;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/Orcamentos/MostrarAvisosNaVenda.vue